import { PAYMENT_PROVIDERS } from '@constants/automations';
import { formatDateOrEmpty } from '@helpers/dates';
import { formatMoney } from '@helpers/formatNumbers';

const PAYMENT_SOURCES = ['CARD', 'BANK_ACCOUNT', 'WALLET', 'BUY_NOW_PAY_LATER', 'SQUARE_ACCOUNT', 'CASH', 'EXTERNAL'];

const isShownValue = value => typeof value === 'string' && value !== '';

const isHttpsUrl = value => typeof value === 'string' && /^https:\/\//i.test(value);

const paymentSource = (sourceType, t) =>
    PAYMENT_SOURCES.includes(sourceType) ? t(`ContactsPage.paymentDetails.sources.${sourceType}`) : sourceType;

const purchaseNumber = (data, t) => {
    if (data.firstPaymentForContact) return t('ContactsPage.paymentDetails.firstPurchase');
    return Number.isFinite(data.paymentCount)
        ? t('ContactsPage.paymentDetails.purchaseNumber', { count: data.paymentCount })
        : null;
};

export const getPaymentDetailRows = (data, { t, language, locationsMap }) => {
    const provider = PAYMENT_PROVIDERS.find(option => option.value === data.provider)?.label;
    const rows = [
        { key: 'amount', value: Number.isFinite(data.amount) ? formatMoney(data.amount, data.currency) : null },
        { key: 'location', value: locationsMap?.[data.locationId]?.internalName },
        { key: 'paidAt', value: data.paidAt ? formatDateOrEmpty(data.paidAt, 'd MMM yyyy, HH:mm', language) : null },
        { key: 'method', value: paymentSource(data.sourceType, t) },
        { key: 'account', value: [provider, data.accountName].filter(isShownValue).join(' · ') },
        { key: 'purchase', value: purchaseNumber(data, t) },
    ];

    return {
        rows: rows
            .filter(row => isShownValue(row.value))
            .map(row => ({ ...row, label: t(`ContactsPage.paymentDetails.${row.key}`) })),
        receiptUrl: isHttpsUrl(data.receiptUrl) ? data.receiptUrl : null,
    };
};
